import { getDocument } from "@faire/web/common/globals/getDocument";

export const copyTextToClipboard = (text: string) => {
  // seems to be the best way to get something into the clipboard
  // https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
  const document = getDocument();
  if (!document) {
    return;
  }
  const el = document.createElement("textarea");
  el.value = text;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};
